<template>
	<div>
		<div class="" style="padding-top: 50px;">
			<infoList v-if="justList" :column_code="columnCode"></infoList>
			<downList v-if="!justList" :column_code="columnCode">
			</downList>
		</div>
	</div>
</template>

<script>
	import infoList from '../components/infoList.vue'
	import downList from '../components/download_list.vue'
	export default {
		data() {
			return {
				columnCode: '',
				title: '',
				justList:true
			}
		},
		components: {
			infoList,
			downList
		},
		created() {
			if(parseInt(localStorage.getItem('columnStatus')) == 8){
				this.justList = false
			}
			setTimeout(() => {
				this.columnCode = localStorage.getItem('columnCode')
				console.log('this.columnCode', this.columnCode)
			})
		}
	}
</script>

<style>
</style>
